"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@opensea/next-ui-kit";
import { classNames, useToasts } from "@opensea/ui-kit";
import { Edit } from "@opensea/ui-kit/icons";
import { useTranslations } from "next-intl";
import { useDropzone } from "react-dropzone";
import { collectionLogo } from "@/components/collection/drops/constants";
import { useOverviewPreviewStore } from "@/components/collection/overview/components/OverviewPreviewProvider/OverviewPreviewProvider";
import { COLLECTION_PREVIEW_INTERACTIVE_ELEMENT_CLASS_NAME } from "@/components/collection/overview/constants";
import { useCollectionImageUpload } from "@/hooks/use-collection-image-upload";
import { readFileAsDataURL } from "@/lib/upload";
export function CollectionLogoEditActions() {
  const $ = _c(22);
  const t = useTranslations("CollectionLogoEditActions");
  const {
    showErrorMessage,
    showSuccessMessage
  } = useToasts();
  const slug = useOverviewPreviewStore(_temp);
  const updateLogoData = useOverviewPreviewStore(_temp2);
  const {
    upload,
    isUploading
  } = useCollectionImageUpload(slug, "PROFILE_PICTURE");
  let t0;
  if ($[0] !== showErrorMessage || $[1] !== showSuccessMessage || $[2] !== t || $[3] !== updateLogoData || $[4] !== upload) {
    t0 = async acceptedFiles => {
      if (!acceptedFiles.length) {
        return;
      }
      try {
        const file = acceptedFiles[0];
        const imageUrlPromise = readFileAsDataURL(file);
        const {
          token
        } = await upload(file);
        const imageUrl = await imageUrlPromise;
        updateLogoData(imageUrl, token);
        showSuccessMessage(t("uploadSuccess"));
      } catch {
        showErrorMessage(t("uploadError"));
      }
    };
    $[0] = showErrorMessage;
    $[1] = showSuccessMessage;
    $[2] = t;
    $[3] = updateLogoData;
    $[4] = upload;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  let t1;
  if ($[6] !== isUploading || $[7] !== t0) {
    t1 = {
      disabled: isUploading,
      accept: collectionLogo.accept,
      maxFiles: 1,
      maxSize: collectionLogo.maxFileSize,
      onDrop: t0
    };
    $[6] = isUploading;
    $[7] = t0;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  const {
    getRootProps,
    getInputProps
  } = useDropzone(t1);
  let t2;
  if ($[9] !== getRootProps) {
    t2 = getRootProps();
    $[9] = getRootProps;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = classNames(COLLECTION_PREVIEW_INTERACTIVE_ELEMENT_CLASS_NAME, "opacity-0 transition-opacity group-hover:opacity-100");
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== isUploading) {
    t4 = <Button className={t3} disabled={isUploading} icon={Edit} isLoading={isUploading} size="sm" variant="secondary" />;
    $[12] = isUploading;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== getInputProps) {
    t5 = getInputProps();
    $[14] = getInputProps;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t5) {
    t6 = <input {...t5} />;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t2 || $[19] !== t4 || $[20] !== t6) {
    t7 = <div className="absolute inset-0 z-10 flex items-center justify-center" {...t2}>{t4}{t6}</div>;
    $[18] = t2;
    $[19] = t4;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
}
function _temp2(state_0) {
  return state_0.updateLogoData;
}
function _temp(state) {
  return state.slug;
}